import { render, staticRenderFns } from "./header-v2.vue?vue&type=template&id=13fd6b9b&scoped=true&"
import script from "./header-v2.vue?vue&type=script&lang=js&"
export * from "./header-v2.vue?vue&type=script&lang=js&"
import style0 from "./header-v2.vue?vue&type=style&index=0&id=13fd6b9b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fd6b9b",
  null
  
)

export default component.exports